module.exports = __webpack_public_path__ + "static/media/close.57c9719f.webp";